import { lighten } from "@mui/material/styles";
import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  dialogInfoBox: {
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 8,
    overflow: "hidden",
    marginBottom: 20,
  },
  infoRow: {
    display: "flex",
    gap: 10,
    alignItems: "flex-start",
    padding: "10px 14px",
    backgroundColor: lighten(theme.palette.primary.main, 0.88),
    borderLeft: `3px solid ${theme.palette.primary.main}`,
  },
  infoIcon: {
    color: theme.palette.primary.dark,
    width: 16,
    height: 16,
    flexShrink: 0,
    marginTop: 2,
  },
  infoText: {
    margin: 0,
    fontSize: 13,
    lineHeight: "20px",
    color: theme.palette.primary.dark,
  },
  rowDivider: {
    height: 1,
    backgroundColor: theme.palette.grey[200],
  },
  csvRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    padding: "10px 14px",
    backgroundColor: "#FEF3C7",
    borderLeft: "3px solid #D97706",
  },
  csvWarningIcon: {
    color: "#B45309",
    width: 16,
    height: 16,
    flexShrink: 0,
    marginTop: 2,
  },
  csvRowBody: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  csvRowText: {
    fontSize: 13,
    color: "#78350F",
    lineHeight: "20px",
  },
  sampleDownloadBtn: {
    alignSelf: "flex-start",
    background: "none",
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 4,
    padding: "2px 10px",
    fontSize: 12,
    color: theme.palette.primary.main,
    cursor: "pointer",
    lineHeight: "20px",
  },
  dropZone: {
    border: `2px dashed ${theme.palette.grey[400]}`,
    borderRadius: 10,
    padding: "36px 24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    cursor: "pointer",
    backgroundColor: theme.palette.grey[50],
    transition: "background-color 0.15s ease, border-color 0.15s ease",
    userSelect: "none",
  },
  dropZoneDragging: {
    borderColor: theme.palette.primary.main,
    backgroundColor: lighten(theme.palette.primary.main, 0.93),
  },
  dropZoneError: {
    borderColor: theme.palette.error.main,
  },
  dropZoneIconCircle: {
    width: 56,
    height: 56,
    borderRadius: "50%",
    backgroundColor: theme.palette.grey[200],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 4,
    transition: "background-color 0.15s ease",
  },
  dropZoneIconCircleDragging: {
    backgroundColor: theme.palette.primary.lighter,
  },
  dropZoneCloudIcon: {
    color: theme.palette.grey[700],
    width: 28,
    height: 28,
  },
  dropZoneCloudIconDragging: {
    color: theme.palette.primary.main,
  },
  dropZoneTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.grey[900],
    textAlign: "center",
  },
  dropZoneHint: {
    fontSize: 13,
    color: theme.palette.grey[600],
    marginTop: 2,
  },
  dropZoneMeta: {
    marginTop: 6,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2,
  },
  dropZoneMetaText: {
    fontSize: 12,
    color: theme.palette.grey[600],
  },
  dropZoneMetaStrong: {
    color: theme.palette.grey[700],
  },
  fileCard: {
    border: `1.5px solid ${theme.palette.primary.lighter}`,
    borderRadius: 10,
    padding: "16px 18px",
    backgroundColor: lighten(theme.palette.primary.main, 0.93),
  },
  fileCardRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  fileIconBox: {
    width: 44,
    height: 44,
    borderRadius: 8,
    backgroundColor: theme.palette.primary.lighter,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  fileIcon: {
    color: theme.palette.primary.main,
    width: 22,
    height: 22,
  },
  fileInfo: {
    flex: 1,
    minWidth: 0,
  },
  fileName: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.grey[900],
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  fileSize: {
    fontSize: 12,
    color: theme.palette.grey[700],
    marginTop: 2,
  },
  changeFileLink: {
    marginTop: 12,
    background: "none",
    border: "none",
    padding: 0,
    fontSize: 13,
    color: theme.palette.primary.main,
    cursor: "pointer",
    textDecoration: "underline",
    textUnderlineOffset: 2,
    display: "block",
  },
  errorBox: {
    display: "flex",
    alignItems: "flex-start",
    gap: 6,
    marginTop: 8,
    padding: "8px 12px",
    backgroundColor: theme.palette.error.lighter,
    border: `1px solid ${theme.palette.red.light}`,
    borderRadius: 6,
  },
  errorIcon: {
    color: theme.palette.error.dark,
    width: 16,
    height: 16,
    flexShrink: 0,
    marginTop: 1,
  },
  errorText: {
    fontSize: 13,
    color: theme.palette.error.dark,
    lineHeight: "20px",
  },
  progressWrap: {
    marginTop: 12,
  },
  progressRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 6,
  },
  progressPercent: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
}));
